import { MASK_SENSITIVE_DATA } from '@/common/config'
import { FeatureFlagProvider } from '@sennder/shell-utilities'

export const featureFlag = new FeatureFlagProvider({
  maskSensitiveData: MASK_SENSITIVE_DATA,
})
